import React, { useEffect, useState } from "react";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import { RenderForm } from "../../Pages/StateMachine/StateBlueprint/EditActityOption";
import MaterialIcon from "../BuilderComponents/MaterialIcon";
import { getFieldIcon } from "../../utils/getFieldIcon";
import FieldTag from "../../Pages/Form/FieldTags/FieldTag";
import ButtonActionIcon from "../BuilderComponents/ButtonActionIcon";
import { useNavigate, useParams } from "react-router-dom";

const jobTypeMap = {
  workflow: ["perform_activity", "start_state_machine", "perform_activity_rdbms_fe"],
  entity: ["register_entity", "edit_entity_fe", "edit_entity_plus_fe"],
  app_user: ["get_edit_app_user_form"],
  rdbms: ["perform_rdbms_form_fe"]
};

function createStateMachineActivityPath(smId, activityId) {
  return `/state-machine/${smId}/activities/${activityId}`;
}

function createEntityPath(entityId) {
  return `/state-machine/${entityId}`;
}

function createAppUserPath() {
  return `/userConfig`;
}

function createRdbmsPath(rdbmsId) {
  return `/rdbmsform/${rdbmsId}`;
}

function getJobType(jobName) {
  for (const [type, jobs] of Object.entries(jobTypeMap)) {
    if (jobs.includes(jobName)) {
      return type;
    }
  }
  return null;
}

const createJobPath = (jobType, config, globalSmId) => {
  const { sm_id, activity_id, activity_id_init, entity_id, rdbms_form_id } = config?.params || {};
  switch (jobType) {
    case "workflow":
      if (sm_id && activity_id) {
        return createStateMachineActivityPath(sm_id, activity_id);
      } else if (sm_id && activity_id_init) {
        return createStateMachineActivityPath(sm_id, activity_id_init);
      } else if (globalSmId && activity_id) {
        return createStateMachineActivityPath(globalSmId, activity_id);
      }
      return null;
    case "entity":
      return createEntityPath(entity_id);
    case "app_user":
      return createAppUserPath();
    case "rdbms":
      return createRdbmsPath(rdbms_form_id);
    default:
      return null;
  }
};

const FieldsPreview = ({ fields, navigate, path }) => {
  return (
    <div className="w_100 h_100 overflow_hidden">
      <div className="form_field_container" style={{ marginTop: "40px" }}>
        <div style={{ position: "relative" }} className="activity_select_top">
          <div className="form_edit_del_buttons">
            <ButtonActionIcon
              type="edit"
              size="md"
              onClick={() => {
                navigate(path);
              }}
            />
          </div>
          {fields.length > 0 && (
            <div className="form_field_outer">
              <div className="overlay_cover"></div>
              <div>
                {fields.length > 0 && (
                  <div className="stateMachine_form_container">
                    {fields?.map((field) => {
                      const { ...fieldWithoutKey } = field;
                      return (
                        <div key={field.id} className={`single_field_render`}>
                          <MaterialIcon
                            name={getFieldIcon(field.type)}
                            style={{ color: "#667085", marginRight: "8px" }}
                          />
                          <div className="form_element_container">
                            <FieldTag key={field.id} element={fieldWithoutKey} />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const FormPreview = ({ config: buttonConfig, tableId }) => {
  const [activityData, setActivityData] = useState(null);
  const navigate = useNavigate();
  const { appId } = useParams();

  const fetchActivityData = async () => {
    const { job_template } = buttonConfig.config;
    const jobType = getJobType(job_template);
    const path = createJobPath(jobType, buttonConfig.config, tableId);
    if (!path) {
      setActivityData(null);
      return;
    }
    try {
      const response = await axiosInstance.get(path);
      setActivityData(response.data);
    } catch (error) {
      handleApiError(error);
    }
  };

  useEffect(() => {
    if (buttonConfig?.config?.job_id) {
      fetchActivityData();
    }
  }, [buttonConfig?.config?.job_id]); // eslint-disable-line react-hooks/exhaustive-deps

  const renderForm = () => {
    const jobType = getJobType(buttonConfig?.config?.job_template);

    if (jobType === "rdbms" || jobType === "app_user") {
      const fields = jobType === "rdbms" ? activityData?.config?.fields : activityData?.fields;
      const path = jobType === "rdbms" ? `../../${appId}/rdbmsform/${activityData.id}` : `../../${appId}/appuser`;
      return <FieldsPreview fields={fields} navigate={navigate} path={path} />;
    } else {
      const selectedItemData =
        activityData?.config?.sm_type === "entity" ? activityData?.config?.activities?.[0] : activityData;
      return <RenderForm selectedItemData={selectedItemData} tableId={tableId} />;
    }
  };

  return <div className="h_100 overflow_hidden">{activityData ? renderForm() : <p>Form Preview</p>}</div>;
};

export default FormPreview;
